/**
 * South African mobile numbers (local 10-digit form).
 * Accepts 06x / 07x / 081-089 prefixes; also normalizes +27 / 27 inputs.
 */
const SA_MOBILE_LOCAL_REGEX = /^0(6\d|7[0-9]|8[1-9])\d{7}$/;

/** Digits-only local form, e.g. 0721231234. Returns null if invalid. */
export function normalizeSaMobile(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  let digits = value.replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('27') && digits.length === 11) {
    digits = `0${digits.slice(2)}`;
  }
  return SA_MOBILE_LOCAL_REGEX.test(digits) ? digits : null;
}

/** Display form: 072 123 1234 */
export function formatSaMobile(value: string | null | undefined): string {
  const normalized = normalizeSaMobile(value ?? '');
  if (!normalized) {
    const raw = String(value || '').trim();
    return raw;
  }
  return `${normalized.slice(0, 3)} ${normalized.slice(3, 6)} ${normalized.slice(6)}`;
}

/** Angular validator: accepts formatted or raw SA mobiles. */
export function saMobileValidator(control: { value: unknown }): { saMobile: true } | null {
  const raw = String(control.value ?? '').trim();
  if (!raw) return null;
  return normalizeSaMobile(raw) ? null : { saMobile: true };
}
